import React, { useState, useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import FormContainer from '../../../../FormContainer';

import useInvoiceForm from '../../../../../../forms/loan/invoice';
import InvoiceService from '../../../../../../services/InvoiceService';
import { useUiContext } from '../../../../../../context/UiContext';

export default function CreateInvoice({ loanId }) {
  const [readOnly, setReadOnly] = useState(true);

  const navigate = useNavigate();

  // Prevent the form from auto focusing on page load
  useEffect(() => {
    setTimeout(() => {
      setReadOnly(false);
    }, 100);
  }, []);

  const { showToast } = useUiContext();

  const { mutate: createInvoice, isPending } = useMutation({
    mutationFn: (formValues) =>
      InvoiceService.createInvoice({
        loanId,
        formValues,
      }),
    onSuccess: (response) => {
      showToast({
        text: 'Invoice created successfully',
        type: 'success',
      });
      navigate(`/loans/${loanId}/invoices/${response.id}?tab=Invoice`);
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const form = useInvoiceForm(createInvoice, null, loanId);

  return (
    <div className="mb-10">
      <FormContainer
        readOnly={readOnly}
        form={form}
        titleStyle="text-xl"
        noBillComId
        isSubmitting={isPending}
      />
    </div>
  );
}
